// extracted by mini-css-extract-plugin
export default {"dialogPaper":"AddSpeakerModal_dialogPaper__Vlfpk","footer":"AddSpeakerModal_footer__-K9G1","moreInsightsContainer":"AddSpeakerModal_moreInsightsContainer__xSYDe"};